import { NgClass, NgIf, NgStyle } from '@angular/common';
import { Component, input, Input } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TooltipModule } from 'primeng/tooltip';

import { CallPipe } from '../../../pipes/call.pipe';
import { castIcon } from '../../../utils';
import { wpTaskIcon } from 'src/app/svg/wp-task';

export type WPTypeBadge = {
  name: string;
  color: string;
  icon?: string;
};

@Component({
  selector: 'app-wp-type-badge',
  templateUrl: './wp-type-badge.component.html',
  styleUrls: ['./wp-type-badge.component.scss'],
  standalone: true,
  imports: [CallPipe, NgClass, NgIf, NgStyle, SvgIconComponent, TooltipModule],
})
export class WPTypeBadgeComponent {
  @Input({ required: true }) wpType!: WPTypeBadge;
  @Input() labelClasses?: string;
  @Input() showLabel: boolean = true;
  @Input() showTooltip: boolean = true;
  readonly castIcon = castIcon;

  readonly defaultIcon = wpTaskIcon.name;
  readonly size = input<'md' | 'xs' | 'sm' | 'lg'>('md');
}
